import { render, staticRenderFns } from "./ConfigSmsRecipientsList.vue?vue&type=template&id=24add270&scoped=true&"
import script from "./ConfigSmsRecipientsList.vue?vue&type=script&lang=js&"
export * from "./ConfigSmsRecipientsList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSmsRecipientsList.vue?vue&type=style&index=0&id=24add270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24add270",
  null
  
)

export default component.exports